import { Animated } from "react-native";
import { Text } from "react-native-paper";
import Svg from "react-native-svg";
import type { CustomLevelIconName } from "../../../../icons/custom-level-icon-names";
import { useAppTheme } from "../../../../useAppTheme";
import { AnimatedSvgCircle } from "../../../AnimatedSvgCircle";
import Box from "../../../Box";
import { LevelIcon } from "../../../LevelIcon";
import { RING_DIAMETER, RING_ICON_SIZE, RING_STROKE_WIDTH } from "./constants";

type Props = {
	icon: CustomLevelIconName;
	name: string;
	band: string;
	/** 0 → 1 for this node's slice of the draw-in. Timing lives in the parent. */
	progress: Animated.Value;
};

export const ToeicLevelRing = ({ icon, name, band, progress }: Props) => {
	const theme = useAppTheme();

	const radius = (RING_DIAMETER - RING_STROKE_WIDTH) / 2;
	const circumference = radius * 2 * Math.PI;

	// Sweeps the arc closed from the top as progress runs 0 → 1.
	const strokeDashoffset = progress.interpolate({
		inputRange: [0, 1],
		outputRange: [circumference, 0],
	});

	return (
		<Box alignItems="center" gap={8}>
			<Box
				width={RING_DIAMETER}
				height={RING_DIAMETER}
				alignItems="center"
				justifyContent="center"
			>
				<Svg width={RING_DIAMETER} height={RING_DIAMETER}>
					<AnimatedSvgCircle
						cx={RING_DIAMETER / 2}
						cy={RING_DIAMETER / 2}
						r={radius}
						stroke={theme.palette.progress.high}
						strokeWidth={RING_STROKE_WIDTH}
						strokeDasharray={circumference}
						strokeDashoffset={strokeDashoffset}
						strokeLinecap="round"
						fill="none"
						transform={`rotate(-90, ${RING_DIAMETER / 2}, ${RING_DIAMETER / 2})`}
					/>
				</Svg>
				<Box position="absolute">
					<Animated.View style={{ opacity: progress }}>
						<LevelIcon
							name={icon}
							size={RING_ICON_SIZE}
							color={theme.colors.onSurface}
						/>
					</Animated.View>
				</Box>
			</Box>
			<Animated.View style={{ opacity: progress, alignItems: "center" }}>
				<Text variant="labelLarge">{name}</Text>
				<Text
					variant="bodySmall"
					style={{ color: theme.colors.onSurfaceVariant }}
				>
					{band}
				</Text>
			</Animated.View>
		</Box>
	);
};
